export type RoundSchedule = { startTime: number; endTime: number };

export const MIN_BREAK_DURATION_MINUTES = 0;
export const MAX_BREAK_DURATION_MINUTES = 60;
export const MIN_TIMER_DURATION_MINUTES = 0;
export const MAX_TIMER_DURATION_MINUTES = 999;
export const MIN_SESSIONS = 1;
export const MAX_SESSIONS = 50;

export const calculateSchedule = (
  startedAt: number,
  breakDuration: number,
  roundDuration: number,
  rounds: number,
  // eslint-disable-next-line max-params
) => {
  const currentSchedule: RoundSchedule[] = [];

  if (startedAt < 0) {
    return currentSchedule;
  }

  const breakTime = breakDuration * 60 * 1000;
  const roundTime = roundDuration * 60 * 1000;
  let endTime = startedAt + roundTime;

  currentSchedule.push({ startTime: startedAt, endTime });

  // eslint-disable-next-line no-plusplus
  for (let i = 0; i < rounds - 1; i++) {
    const startTime = endTime + breakTime;

    endTime = startTime + roundTime;

    currentSchedule.push({ startTime, endTime });
  }

  return currentSchedule;
};

export const isValidSessionLength = (minutes: number) =>
  minutes > MIN_TIMER_DURATION_MINUTES && minutes <= MAX_TIMER_DURATION_MINUTES;

export const isValidSessionNum = (minutes: number) =>
  minutes >= MIN_SESSIONS &&
  minutes <= MAX_SESSIONS &&
  Number.isInteger(minutes); // don't allow fractional rounds

export const isValidBreakLength = (minutes: number) =>
  minutes >= MIN_BREAK_DURATION_MINUTES &&
  minutes <= MAX_BREAK_DURATION_MINUTES;
